exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.p-borrow[data-v-2125f39e] {\n  height: 100%;\n  overflow: hidden;\n  background: #f0f0f0;\n}\n.p-borrow .borrow__container[data-v-2125f39e] {\n  padding-top: 0.266667rem /* 20/75 */;\n}\n.p-borrow .borrow__container[data-v-2125f39e] .borrow__btn {\n  background: #2489ff;\n  color: #fff;\n  border-radius: 0.106667rem /* 8/75 */;\n  width: 1.626667rem /* 122/75 */;\n  height: 0.826667rem /* 62/75 */;\n  padding: 0;\n  text-align: center;\n  font-size: 0.373333rem /* 28/75 */;\n}\n.p-borrow .borrow__container[data-v-2125f39e] .borrow__btn[disabled] {\n  background: #70b2ff;\n}\n", ""]);

// exports
